var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "371D02D9-039F-4F81-8824-902C6F7D1004") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-246.000000, -574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.000000, 586.000000) scale(-1, -1) rotate(180.000000) translate(-258.000000, -586.000000) translate(246.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38870781,20 C8.32963929,20 8.26981023,19.9885597 8.21276981,19.9648992 C8.03404317,19.8905375 7.91818774,19.7111335 7.92072287,19.513269 L7.9602709,16.6784247 L7.09274953,16.6784247 C5.93875851,16.6784247 5,15.7156229 5,14.5323361 L5,7.14582864 C5,5.96254182 5.93875851,5 7.09274953,5 L16.907504,5 C18.0612415,5 19,5.96254182 19,7.14582864 L19,14.5323361 C19,15.7156229 18.0612415,16.6784247 16.907504,16.6784247 L12.6606548,16.6784247 C12.4020716,16.6784247 12.1926699,16.4633998 12.1926699,16.1984538 C12.1926699,15.9332478 12.4020716,15.718483 12.6606548,15.718483 L16.907504,15.718483 C17.5450891,15.718483 18.0642836,15.1862509 18.0642836,14.5323361 L18.0642836,7.14582864 C18.0642836,6.49191382 17.5450891,5.95968175 16.907504,5.95968175 L7.09274953,5.95968175 C6.45491091,5.95968175 5.93571636,6.49191382 5.93571636,7.14582864 L5.93571636,14.5323361 C5.93571636,15.1862509 6.45491091,15.718483 7.09274953,15.718483 L8.43510068,15.718483 C8.56033609,15.718483 8.68024772,15.7697041 8.76821672,15.8614862 C8.85618572,15.9530083 8.90460669,16.0767711 8.9028321,16.205214 L8.87393162,18.2935813 L11.0820296,15.8937269 C11.2594886,15.7008026 11.5555918,15.6922224 11.7436984,15.8742265 C11.931805,16.0562306 11.9401709,16.3599175 11.7629654,16.5528419 L8.72917572,19.8497166 C8.63867159,19.9477388 8.51495726,20 8.38870781,20",
    fill: "#666666",
    transform: "translate(12.000000, 12.500000) scale(-1, -1) rotate(180.000000) translate(-12.000000, -12.500000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.76387d5f.svg";
export { ForwardRef as ReactComponent };